import React, { Component } from "react";
import { Icon, Modal, Button, Row, Col } from "antd";
import { Translate } from "react-translated";

class AddOnModal extends Component {
    render() {
        return (
            <div style={{ marginBottom: 20 }}>
                <Modal
                    visible={this.props.showModal}
                    onCancel={this.props.hideModal}
                    width={600}
                    footer={null}
                >
                    <h2 style={{ transform: " translate(25%, 20%)" }}>You Didn't Select The B FILE+ <span style={{ color: "red" }}>!</span></h2>
                    <Row gutter={16}>
                        <Col span={23} style={{ margin: 20 }}>
                            <Row>
                                <p style={{ margin: '0px 40px', textAlign: 'center', color: "black" }}>Hey! Are you sure you don't want to enhance your call services further with the B FILE+ plan?</p>
                            </Row>
                            <Row gutter={16} style={{ marginTop: 20 }}>
                                <Col span={12}>
                                    <Button type="primary"
                                        style={{ color: "#F5F5F5", background: "#8D8D8D", border: "none" }}
                                        onClick={this.props.hideModal}>
                                        <Icon type="arrow-left"></Icon>
                                        Go back & select B File+ plan</Button>
                                </Col>
                                <Col span={12}>
                                    <Button
                                        style={{ color: "#F5F5F5", background: "#456DAC" }}
                                        onClick={() => {
                                            this.props.hideModal()
                                            this.props.submit()
                                        }}>
                                        Register without B File+ plan</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal>
            </div >
        );
    }
}

export default AddOnModal;


// WEBPACK FOOTER //
// ./src/scenes/Register/parts/add-on-modal.js